import { useContext, useState } from 'react';
import * as uuid from 'uuid';

import HeroPrompt from '../../../components/HeroPrompt';
import ChatWindow from '../../../components/Chat/Conversation';
import { ConversationContext } from '../../../context/conversationContext';
import { AssistantRenderProps } from '../common';

interface Props extends AssistantRenderProps {
  compact?: boolean;
}

const HeroComponent: React.FC<Props> = ({
  handleOnClose,
  handleOnOpen,
  isChatOpen,
  compact,
}) => {
  const [isSubmittingMessage, setIsSubmittingMessage] = useState(false);
  const conversationContext = useContext(ConversationContext);

  if (!conversationContext) return <></>;

  return (
    <>
      {isChatOpen ? (
        <ChatWindow
          onClose={() => handleOnClose()}
          setIsSubmitting={setIsSubmittingMessage}
          isSubmitting={isSubmittingMessage}
        />
      ) : null}
      <HeroPrompt
        compact={compact}
        onInputSubmit={(inputValue) => {
          if (!inputValue) return;
          if (!isSubmittingMessage) {
            conversationContext.addNewMessage({
              question: inputValue,
              chat_message_id: uuid.v4(),
              done: true,
              disabled: true,
            });
          }
          handleOnOpen();
        }}
      />
    </>
  );
};

export default HeroComponent;
